import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";
import "@/styles/portfolio.css";
import "@/styles/blog.css";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/posts");
        setPosts(data);
      } catch (e) {
        setError("Posts konnten nicht geladen werden.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="blog-page" data-testid="blog-list-page">
      <header className="blog-top">
        <Link to="/" className="blog-back" data-testid="blog-back-link">
          ← Zurück
        </Link>
        <Link to="/" className="blog-logo">content.by.max</Link>
        <span className="blog-top__spacer" />
      </header>

      <section className="blog-hero">
        <span className="eyebrow">JOURNAL</span>
        <h1 className="display blog-hero__title">
          Tipps für lokale <span className="italic">Unternehmen</span>.
        </h1>
        <p className="lead blog-hero__lead">
          Gedanken zu Instagram Reels, Social Media Marketing und Content
          Creation für Restaurants, Cafés und Dienstleister in Baden, Wien und
          Umgebung.
        </p>
      </section>

      <section className="blog-grid-wrap">
        {loading && <p className="blog-empty">Lädt…</p>}
        {error && <p className="blog-empty">{error}</p>}
        {!loading && !error && posts.length === 0 && (
          <p className="blog-empty">Noch keine Beiträge.</p>
        )}
        <ul className="blog-grid" data-testid="blog-grid">
          {posts.map((p) => (
            <li
              key={p.id}
              className="blog-card"
              data-testid={`blog-card-${p.slug}`}
            >
              <Link to={`/blog/${p.slug}`} className="blog-card__link">
                <div className="blog-card__media">
                  {p.cover_image ? (
                    <img
                      src={p.cover_image}
                      alt={p.title}
                      className="blog-card__img"
                      loading="lazy"
                    />
                  ) : (
                    <div className="blog-card__placeholder" aria-hidden="true">
                      <span className="blog-card__monogram">cbm</span>
                    </div>
                  )}
                </div>
                <div className="blog-card__body">
                  <span className="blog-card__date">{formatDate(p.created_at)}</span>
                  <h2 className="blog-card__title">{p.title}</h2>
                  <p className="blog-card__excerpt">{p.excerpt}</p>
                  <span className="blog-card__cta">
                    Weiterlesen <span aria-hidden="true">→</span>
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      <footer className="blog-footer">
        <Link to="/#kontakt" className="btn btn--ghost" data-testid="blog-cta-contact">
          <span>Jetzt anfragen</span>
          <span className="btn__arrow">→</span>
        </Link>
        <p className="blog-footer__legal">
          © {new Date().getFullYear()} content.by.max · Max Wendl
        </p>
      </footer>
    </div>
  );
}
